import { useContext } from "react";
import { UserContext } from "./Provider";

const useUser = () => {
  return useContext(UserContext);
};

export default useUser;
